import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Tip from './Tip';
import moment from 'moment';
import { getTip } from "../../functions/tip"

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%"
        },
    }
}));

const ListTip = () => {

    const styles = useStyles();

    const [tips, setTips] = useState([]);

    useEffect(() => {
        getTip().then(res => {
            setTips(res);
            console.log(res)
        })
        return;
    }, []);

    return (
        <>
            <div>
                <h2>
                    tip 게시판
                </h2>
            </div>
            <div className={styles.container}>
                {tips.map((tip, index) => {
                    return (
                        <Tip
                            key={index}
                            title={tip.title}
                            content={tip.content}
                            date={moment(tip.date).format('YYYY.MM.DD')}
                            likes={tip.likes}
                            author={tip.author}
                            liked_users={tip.liked_users}
                            category={tip.category}
                        />
                    )
                })}
            </div>
        </>
    );
};

export default ListTip;